var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComboDetailStoreWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1253_173094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25098 16.6901C6.61633 16.326 6.1875 15.6422 6.1875 14.8594C6.1875 11.6285 8.81598 9 12.0469 9H14.4615L14.5752 7.125H0.893555L1.87628 23.3394C1.8988 23.7105 2.20624 24 2.57812 24H6.89246C6.45007 23.412 6.1875 22.6815 6.1875 21.8906C6.1875 20.9789 6.76904 20.2006 7.58057 19.9067C7.29291 19.4656 7.125 18.9397 7.125 18.375C7.125 17.8098 7.29327 17.2833 7.58148 16.8419C7.35223 16.7902 7.22498 16.7395 7.25098 16.6901Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73364 5.71893C7.73419 5.71893 7.73474 5.71875 7.73529 5.71875H14.7656C15.154 5.71875 15.4688 5.40399 15.4688 5.01562C15.4688 4.62726 15.154 4.3125 14.7656 4.3125H9.03241L10.9277 1.40625H13.3594C13.7477 1.40625 14.0625 1.09149 14.0625 0.703125C14.0625 0.314758 13.7477 0 13.3594 0H10.5469C10.3092 0 10.0876 0.119934 9.95801 0.31897L7.35352 4.3125H0.703125C0.314758 4.3125 0 4.62726 0 5.01562C0 5.40399 0.314758 5.71875 0.703125 5.71875H7.73108C7.73199 5.71875 7.73291 5.71893 7.73364 5.71893Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59375 14.8594C7.59375 15.2477 7.90851 15.5625 8.29688 15.5625H23.2969C23.6852 15.5625 24 15.2477 24 14.8594C24 12.4039 22.0023 10.4062 19.5469 10.4062H12.0469C9.59143 10.4062 7.59375 12.4039 7.59375 14.8594Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 16.9688C9.16077 16.9688 8.53125 17.5983 8.53125 18.375C8.53125 19.1517 9.16077 19.7812 9.9375 19.7812H21.6562C22.433 19.7812 23.0625 19.1517 23.0625 18.375C23.0625 17.5983 22.433 16.9688 21.6562 16.9688H9.9375Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 21.1875H8.29688C7.90851 21.1875 7.59375 21.5023 7.59375 21.8906C7.59375 23.0537 8.54004 24 9.70312 24H21.8906C23.0537 24 24 23.0537 24 21.8906C24 21.5023 23.6852 21.1875 23.2969 21.1875Z",
    fill: "#50429B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1253_173094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboDetailStoreWeb);
export default __webpack_public_path__ + "static/media/combo-detail-store-web.110d64d33467b4bdd98f2520eb322a82.svg";
export { ForwardRef as ReactComponent };